// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site__links[data-v-9b77c50a]{position:relative;margin-top:20px}.dummy[data-v-9b77c50a]{background:linear-gradient(180deg,#b9b9b9,#ccc);height:60px;margin-bottom:var(--p-btn-margin-bottom)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
